import Tools from '@/components/tools/Tools.js'

export default {
  name: 'TableSalesReportsBroker',
  props: ['columns', 'dataProposta', 'dataEnterprise', 'verificarMes', 'i', 'showHeader', 'dataSales'],

  data () {
    return {
      rows: [],
      totalSaleValue: 0,
      title: 'N/A'
    }
  },

  mounted () {
    let objFilter = {}
    this.title = this.dataSales[0].nomeEmpreendimento
    this.dataSales.forEach(sale => {
      this.totalSaleValue += sale.valorVenda
      if (objFilter[sale.nomeCorretor] === undefined) {
        objFilter[sale.nomeCorretor] = {
          nomeCorretor: sale.nomeCorretor,
          quantidadeVendas: 1,
          valorTotal: sale.valorVenda,
          data: sale.data
        }
      } else {
        objFilter[sale.nomeCorretor].quantidadeVendas += 1
        objFilter[sale.nomeCorretor].valorTotal += sale.valorVenda
      }
    })
    this.rows = Object.values(objFilter)
  },

  methods: {
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    calculaSalesEnterprise (proposta) {
      let total = 0
      proposta.forEach((p) => {
        if (new Date(p.dataVenda).getMonth() === this.i) total = total + p.valorTotal
      })
      proposta.forEach((p) => {
        total = total + p.valorTotal
      })
      return total
    },
    calcularProposta (id) {
      let total = 0
      let proposta = this.dataEnterprise.proposta.filter((Element) => Element.contaId === id)
      proposta.forEach((Element) => {
        total = total + Element.valorTotal
      })
      return total
    },
    calcularTotalVenda (id) {
      let total = 0
      let proposta = this.dataEnterprise.proposta.filter((Element) => Element.contaId === id)
      proposta.forEach((Element) => {
        total++
      })
      return total
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesreportsbroker/components/tablesalesreportsbroker/tablesalesreportsbroker.js